import React, { useContext, useState } from "react";
import AuthContext from "../context/AuthContext";
import { acceptFriendRequest, declineFriendRequest } from "../api/UserAPI";

export default function FriendReqForm({ request }) {
  const { token } = useContext(AuthContext);
  const [status, setStatus] = useState(null);

  async function handleAccept() {
    try {
      const data = await acceptFriendRequest(request.id, request.from_username, token);
      setStatus("Accepted");
    } catch (err) {
      console.error(err);
    }
  }

  async function handleDecline() {
    try {
      const data = await declineFriendRequest(request.id, request.from_username, token);
      setStatus("Declined");
    } catch (err) {
      console.error(err);
    }
  }

  return (
    <div>
      <p className="mb-2">
        <strong>{request.from_username}</strong> wants to be friends!
      </p>
      {status === null ? (
        <div className="flex flex-col mb-4">
          <button
            className="border rounded-full border-black hover:bg-green-500 hover:text-white mb-1"
            onClick={handleAccept}
          >
            Accept
          </button>
          <button
            className="border rounded-full border-black hover:bg-red-500 hover:text-white"
            onClick={handleDecline}
          >
            Decline
          </button>
        </div>
      ) : (
        <p>{status}</p>
      )}
    </div>
  );
}
